export default __webpack_public_path__ + "static/media/intro-3.7204b312.png";